// extracted by mini-css-extract-plugin
export default {"categoriesBanner":"SingleBanner_categoriesBanner__wbBxz","longDesc":"SingleBanner_longDesc__B5QIo","list":"SingleBanner_list__tPhP8"};